module.exports = __webpack_public_path__ + "img/facebook-icon.acd025cf.svg";